<template>
  <div>
  <ejs-button ref='startBtn' cssClass="e-small" style="margin-right:10px;"
    :isPrimary="true" :isToggle="true"
    v-on:click.native="startClick">{{ startContent }}</ejs-button>
    <ejs-button ref='stopBtn' cssClass="e-small"
                :isPrimary="true" :isToggle="true"
                v-on:click.native="stopClick">{{$ts('TS.ts_task_oper_stop')}}</ejs-button>
  </div>
</template>

<script>
import Vue from 'vue';
import { ButtonPlugin } from '@syncfusion/ej2-vue-buttons';
import { enableRipple } from '@syncfusion/ej2-base';
import i18n from '../../../../plugins/i18n.js';
import socketInstance from '../../../../plugins/stompSock.js';
import { EventBus } from '../../../../plugins/eventBus';

enableRipple(true);
Vue.use(ButtonPlugin);

export default {
  name: 'TaskOperButton',
  data() {
    return {
      startContent: this.$ts('TS.ts_task_oper_start'),
      stopContent: this.$ts('TS.ts_task_oper_stop'),
      taskId: '',
      payload: [
      { topic: '/user/#/TSTaskServer', clientId: '', callback: this.subscribeCallback }
      ]
    };
  },
  methods: {
    websocketConnect() {
      if(this.taskId !== '' && this.taskId !== undefined){
        this.payload[0].clientId = this.taskId;
        if (socketInstance.stompClient == null) {
          socketInstance.init(this.payload);
        } else {
          socketInstance.dynamicSubscribe('/user/#/TSTaskServer', this.taskId, this.subscribeCallback);
        }
      }
    },
    subscribeCallback(msg) {
      console.log(msg);
      const data = JSON.parse(msg.body);
      if (data.ErrorCode === '0') {
        this.$refs.startBtn.$parent.$data.data.taskState = data.Parameters.TASKSTATE;
        EventBus.$emit('toast', { type: 'success', content: this.$ts('Common.tips.success') });
      } else {
        EventBus.$emit('toast', { type: 'error', content: data.ErrorCode });
      }
      socketInstance.stopReceiveTopicMsg(data.Parameters.TASKID, '/user/#/TSTaskServer');
    },
    startClick() {
      /* const neType = `${this.$refs.startBtn.$parent.$data.data.neType}`;// 3000tcf网元不能进行操作
      if (neType === '106') {
        EventBus.$emit('toast', { type: 'warning', content: this.$ts('TS.ts_cannot_operate') });
        return;
      } */
      const taskID = `${this.$refs.startBtn.$parent.$data.data.taskID}`;
      this.taskId = taskID;
      // this.websocketConnect();待TCF网元回复响应统一处理
      if (this.$refs.startBtn.$parent.$data.data.taskState === 1) {
        // this.$layer.alert({ msg: this.$ts('TS.ts_have_start_task') });
        EventBus.$emit('toast', { type: 'warning', content: this.$ts('TS.ts_have_start_task') });
      } else {
        const $this = this;
        this.axios.get(`/lte/ems/ts/startTask.html?taskID=${taskID}`).then((response) => {
          if (response.data.errorCode === 'SUCCESS') {
            if (response.data.resultVal === 2) {
              EventBus.$emit('toast', { type: 'error', content: this.$ts('TS.ts_neOffLine')});
            } else if (response.data.resultVal === 0) {
              EventBus.$emit('toast', { type: 'error', content: this.$ts('TS.ts_fail') });
            } else {
              $this.$refs.startBtn.$parent.$data.data.taskState = 1;
              EventBus.$emit('toast', { type: 'success', content: this.$ts('TS.success') });
            }
            // $this.$refs.startBtn.$parent.$data.data.taskState = 1;
          } else {
            // this.$layer.alert({ msg: `${response.data.errorString}` });
            EventBus.$emit('toast', { type: 'error', content: response.data.errorString });
          }
        });
      }
    },
    $ts(args) {
      const mes = args.split('.');
      const result = (mes[0] && mes[1] && i18n.messages[i18n.locale][mes[0]][mes[1]]) ? i18n.messages[i18n.locale][mes[0]][mes[1]] : args;
      return result;
    },
    stopClick() {
      /* const neType = `${this.$refs.startBtn.$parent.$data.data.neType}`;// 3000tcf网元不能进行操作
      if (neType === '106') {
        EventBus.$emit('toast', { type: 'warning', content: this.$ts('TS.ts_cannot_operate') });
        return;
      } */
      const taskID = `${this.$refs.stopBtn.$parent.$data.data.taskID}`;
      this.taskId = taskID;
      // this.websocketConnect();待TCF网元回复响应统一处理
      if (this.$refs.startBtn.$parent.$data.data.taskState === 0) {
        // this.$layer.alert({ msg: this.$ts('TS.ts_have_stop_task') });
        EventBus.$emit('toast', { type: 'warning', content: this.$ts('TS.ts_have_stop_task') });
      } else {
        this.axios.get(`/lte/ems/ts/stopTask.html?taskID=${taskID}`).then((response) => {
          console.log(response);
          if (response.data.errorCode === 'SUCCESS') {
            if (response.data.resultVal === 2) {
              EventBus.$emit('toast', { type: 'error', content: this.$ts('TS.ts_neOffLine')});
            } else if (response.data.resultVal === 0) {
              EventBus.$emit('toast', { type: 'error', content: this.$ts('TS.ts_fail') });
            } else {
              this.$refs.startBtn.$parent.$data.data.taskState = 0;
              EventBus.$emit('toast', { type: 'success', content: this.$ts('TS.success') });
            }
          } else {
            // this.$layer.alert({ msg: `${response.data.errorString}` });
            EventBus.$emit('toast', { type: 'error', content: response.data.errorString });
          }
        });
      }
    }
  }
};
</script>

<style>

</style>
